import { useSmartAccountInitialization } from './useSmartAccountInitialization';
import { useJoinTableBatchSession } from './useJoinTableBatchSession';
import { useRebuyBatchSession } from './useRebuyBatchSession';
import { useRedeemBatchSession } from './useRedeemBatchSession';
import { useSessionKeyAndStorageClient } from './useSessionKeyAndStorageClient';

export const useAccountAbstractionInitialization = () => {
  useSmartAccountInitialization();
  useSessionKeyAndStorageClient();
  useJoinTableBatchSession();
  useRebuyBatchSession();
  useRedeemBatchSession();
};
